import React, { Component } from 'react'
import './index.less'
import score from 'src/helper/score'

import Header from '../Header'
import Rank from '../Rank'

export default class extends Component {
  render() {
    const {
      isShow,
      myRoom,
      roomList,
      headWear1,
      headWear2,
      headWear3,
      bigBg,
      bgColor1,
      bgColor2
    } = this.props
    const top1 = roomList[0]
    const top2 = roomList[1]
    const top3 = roomList[2]

    return (
      <div className='nt-room-wrap' style={{ display: `${isShow ? "block" : "none"}` }}>
        <div className="nt-top-user" style={{ background: `linear-gradient(to bottom, ${bgColor1}, ${bgColor2})` }}>
          <div className="top-main" style={{ backgroundImage: `url(${bigBg})` }}>
            <div className="top1">
              <Header
                userOrRoom={"room"}
                userId={top1 && top1.gid}
                userAvatar={top1 && top1.logourl}
                scaleSize={1}
                headWear={headWear1}
              />
              <div className="name">{top1 && top1.name}</div>
              <div className="id">{top1 && top1.dgid}</div>
              <div className="gold">{score(top1 && top1.val)}</div>
            </div>
            <div className="top23">
              <div className="top2">
                <Header
                  userOrRoom={"room"}
                  userId={top2 && top2.gid}
                  userAvatar={top2 && top2.logourl}
                  scaleSize={1}
                  headWear={headWear2}
                />
                <div className="name">{top2 && top2.name}</div>
                <div className="id">{top2 && top2.dgid}</div>
                <div className="gold">{score(top2 && top2.val)}</div>
              </div>
              <div className="top3">
                <Header
                  userOrRoom={"room"}
                  userId={top3 && top3.gid}
                  userAvatar={top3 && top3.logourl}
                  scaleSize={1}
                  headWear={headWear3}
                />
                <div className="name">{top3 && top3.name}</div>
                <div className="id">{top3 && top3.dgid}</div>
                <div className="gold">{score(top3 && top3.val)}</div>
              </div>
            </div>
          </div>
          {
            roomList && roomList.map((item, index) => {
              if (index > 2) {
                return (
                  <div className="nt-room-list" key={index}>
                    <Rank
                      userOrRoom={"room"}
                      userId={item && item.gid}
                      order={item.rank}
                      avatar={item.logourl}
                      name={item.name}
                      id={item.dgid}
                      gold={item.val} />
                  </div>
                )
              }
            })
          }
          <div className="nt-myrank">
            <Rank
              userOrRoom={"room"}
              userId={myRoom && myRoom.gid}
              order={myRoom && myRoom.rank}
              avatar={myRoom && myRoom.logourl}
              name={myRoom && myRoom.name}
              id={myRoom && myRoom.dgid}
              gold={myRoom && myRoom.val}
            />
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/nationalTemplate/RoomPart/index.js